import React from 'react';
import PropTypes from 'prop-types';

const WarningBox = ({ children }) =>
{
  if (!children) return null;

  return (
    <div className="-wa-edit-controls__warning-box">
      <div className="-wa-edit-controls__warning-message">
        {children}
      </div>
    </div>
  );
};

WarningBox.propTypes = {
  children: PropTypes.element
};

WarningBox.defaultProps = {
  children: null
};

export default WarningBox;